import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/i18n/I18nProvider";

export default function NotFound() {
  const { lang, t } = useI18n();
  return (
    <section className="zx-notfound">
      <div className="zx-notfound__inner">
        <span className="zx-eyebrow">404</span>
        <h1 className="zx-h2">{t("nav.home")}</h1>
        <p>{t("hero.subtitle")}</p>
        <Link to={`/${lang}`} className="zx-btn zx-btn--primary">{t("nav.home")}</Link>
      </div>
    </section>
  );
}
